import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button 
      className="theme-toggle" 
      onClick={toggleTheme} 
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 3C10.8065 4.19347 10.136 5.81217 10.136 7.5C10.136 11.0899 13.0461 14 16.636 14C18.3239 14 19.9426 13.3295 21.136 12.136C20.3322 16.5091 16.5091 19.864 12 19.864C7.02944 19.864 3 15.8345 3 10.864C3 6.35488 6.35488 2.53217 10.7279 1.72834C10.364 2.09562 10.0462 2.49562 9.77348 2.90994C9.31411 3.60158 9 4.39666 9 5.24154" 
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 2V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M12 20V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M4 12L2 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M22 12L20 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M19.7778 4.22266L17.5558 6.25424" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M4.22217 4.22266L6.44418 6.25424" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M6.44434 17.5557L4.22211 19.7779" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M19.7778 19.7773L17.5558 17.5551" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle; 